import { createSelector } from 'reselect';
import {
  mapDashboardDataToChartView,
  mapDashboardDataToCumulLastDayAnnual,
} from 'helpers/chartDataMappers';
import { selectCurrentCompanyFirstFiscalMonth } from 'modules/turnoverPage/selectors';
import { selectUserCurrentCompanyExercice } from '../../loggedUserInfo/selectors';

export const selectCreditorsStatus = (state) => state.creditors?.status;

export const selectCreditors = (state) => state.creditors?.data || [];

export const selectCreditorsDatasets = (state) =>
  state.creditors?.datasets || [];

export const selectCreditorsLastUpdated = (state) =>
  state.creditors?.lastUpdated || new Date(Date.now()).toISOString();

export const selectCreditorsDataForCharts = createSelector(
  [selectCreditorsDatasets, selectUserCurrentCompanyExercice],
  (creditorsDatasets, currentExercice) =>
    mapDashboardDataToChartView(creditorsDatasets, 'credits', currentExercice)
);

export const selectCreditorsYearData = createSelector(
  [selectCurrentCompanyFirstFiscalMonth, selectCreditorsDataForCharts],
  (firstMonthName, creditorsChartData) =>
    mapDashboardDataToCumulLastDayAnnual(creditorsChartData, firstMonthName)
);

export const selectCreditorPageData = createSelector(
  [(state) => state.creditors?.current],
  (pageInfo) => {
    if (!pageInfo) return { data: [] };

    const { data, ...rest } = pageInfo;
    return {
      ...rest,
      data: data || [],
    };
  }
);
